export const getContactsViewKey = (activeNetwork, listId, isSharedList = false) =>
  `contacts-view-${activeNetwork?.id}${listId ? `-list-${listId}${isSharedList ? '-shared-list' : ''}-v1.0` : ''}`;

export const getContactsFiltersKey = (activeNetwork, listId, page) =>
  `contacts-filters-${activeNetwork?.id}${listId ? `-list-${listId}` : ''}${page ? `-page-${page}` : ''}-v1.0`;

export const getContactsColumnsKey = ({ activeNetwork, listId, type, showJobsData, joinTnFromJB }) => {
  const parts = ['contacts-columns'];

  parts.push(activeNetwork?.id);

  if (activeNetwork?.tnHidden) {
    parts.push('tn-hidden');
  }

  if (listId) {
    parts.push(`list-${listId}`);
  }

  if (type === 'public') {
    parts.push('public');
  }

  if (showJobsData) {
    parts.push('show-jobs-data');
  }

  if (joinTnFromJB) {
    parts.push('join-tn-from-jb');
  }

  parts.push('v1.23');

  return parts.join('-');
};
